import React, { useState, useEffect, useContext } from 'react';
import { Breadcrumb, Card, Col, Row, Tabs } from "antd";
import Icofont from "react-icofont";
import { errorCatch, READ, uncapitalize } from '../../components/Tool';
import { Link, Route, useRouteMatch } from "react-router-dom";
import { useUserContext } from '../../components/Context';
import { useAuth } from '../../components/Auth';
import AbstractCollection from '../../components/AbstractCollection';
import Model from '../../components/Model';
import { useSelector } from 'react-redux';
import CollectionServer from '../../components/CollectionServer';
var _ = require('lodash');

const { TabPane } = Tabs;

export default function SystemFunctions(props) {
    const auth = useAuth();
    const user = useUserContext();

    const meta = useSelector(state => state.meta);
    const name = "fsmfunctions";

    const filtersFromMeta = React.useCallback(() => {
        let prop = [];
        let p = _.get(meta[name.toLowerCase()], "properties");
        if (p) {
            prop = p.filter(e => _.get(e, "relation.type") !== "one-many").map(e => ({ ...e, sort: true, filter: true, func: (e.filterType === "range")?["min", "max"]:undefined }))
        }
        return prop;
    }, [meta, name]);

    return (<>
        <Breadcrumb style={{ margin: '16px 16px' }}>
            <Breadcrumb.Item>Система</Breadcrumb.Item>
            <Breadcrumb.Item>Функции</Breadcrumb.Item>
        </Breadcrumb>

        <div style={{ padding: 12, minHeight: 360, backgroundColor: "white", height:"100%" }}>
            <Col span={24}>
                <Card size="small" bordered={false}>
                    {meta &&
                    
                    // <AbstractCollection
                    //     auth={auth}
                    //     name={fsmfunctionsMeta.name}
                    //     columns={() => fsmfunctionsMeta.properties.filter(n => n.type === "string").map((n, idx) => ({
                    //         key: idx,
                    //         title: n.label,
                    //         render: (text, record, index) => {
                    //             return (record[uncapitalize(n.name)]);
                    //         }
                    //     }))}
                        
                    //     form={Model}
                    //     meta={fsmfunctionsMeta.properties}
                    // />
                    
                    <CollectionServer
                    auth={auth}
                    name={name}
                    filters={filtersFromMeta}
                    columns={({ auth, collection, setCollection, request }) => [
                        {
                            key: "0",
                            title: "Название",
                            render: (text, record, index) => {
                                return (record.name);
                            }
                        },
                        {
                            key: "1",
                            title: "Описание",
                            render: (text, record, index) => {
                                return (record.description);
                            }
                        },
                        {
                            key: "1",
                            title: "Клиентская",
                            render: (text, record, index) => {
                                return (record.isClient)?"Да":"Нет";
                            }
                        }
                    ]}
                    size={"small"}
                    defaultModelActions={true}
                    defaultCollectionActions={true}
                />}
                </Card>
            </Col>
        </div>
    </>);
}